import { Button, Select, Space, Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import { User } from '../../../interfaces/api/Auth';
import { OnboardingStepProps } from '.';

const { Text } = Typography;

const userRoleOptions = [
  { label: 'Software Developer', value: 'developer' },
  { label: 'Software Architect', value: 'architect' },
  {
    label: 'CTO/VP/Lead',
    value: 'technical manager'
  },
  { label: 'PM', value: 'pm' },
  { label: 'Consultant', value: 'consultant' },
  { label: 'Student', value: 'student' },
  { label: 'Other', value: 'other' }
];

interface UserQuestionsStepProps extends OnboardingStepProps {
  user: User | undefined;
}

const UserQuestionsStep: React.FC<UserQuestionsStepProps> = ({ next }) => {
  const [tempUserRole, setTempUserRole] = useState('');
  const shouldDisableNextButton = tempUserRole === '';

  return (
    <>
      <Space direction="vertical" style={{ marginTop: 20, marginBottom: 20 }}>
        <Text>What is your role/position?</Text>
        <Select
          style={{ width: 300 }}
          onChange={(value) => setTempUserRole(value)}
          options={userRoleOptions}
        />

        <Tooltip
          title={shouldDisableNextButton ? 'Please answer all questions' : ''}
          placement="right"
        >
          <Button
            type="primary"
            disabled={shouldDisableNextButton}
            onClick={() => {
              if (window.Intercom) {
                window.Intercom('update', { Role: tempUserRole });
              }
              next();
            }}
          >
            Next
          </Button>
        </Tooltip>
      </Space>
    </>
  );
};

export default UserQuestionsStep;
